/*
 * TRAINER COURT CUSTOM — filter bar (step 1) + All Filters drawer (step 2)
 * + mobile (step 3: bar buttons open the drawer as a bottom sheet for one filter)
 * + step 4: Set list grouped by era, price presets, Under $10 toggle
 * + phase 2: search page bar, card search on Singles pages
 * Opens/closes the bar's dropdowns and keeps the open one open while results
 * update. Applying filters is done by the theme's own facets.js: the bar is a
 * <facet-filters-form>, so ticking a box submits it like the theme's filters
 * (results update without a page reload, and the bar is redrawn with them).
 */
(function () {
  if (window.TcFilterBar) return;
  var TC = window.TcFilterBar = { reopen: null };

  // Phones and small tablets: the theme's own breakpoint is 1068px.
  function isMobile() { return window.matchMedia('(max-width: 1067px)').matches; }

  function bar() { return document.querySelector('[data-tc-bar]'); }
  function form() { var b = bar(); return b ? b.querySelector('form') : null; }

  function submit() {
    var f = form();
    if (f) f.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function closeAll(except) {
    document.querySelectorAll('.tc-dd.is-open').forEach(function (dd) {
      if (dd === except) return;
      dd.classList.remove('is-open');
      var btn = dd.querySelector(':scope > .tc-btn');
      var panel = dd.querySelector(':scope > .tc-panel');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  function open(dd) {
    closeAll(dd);
    var btn = dd.querySelector(':scope > .tc-btn');
    var panel = dd.querySelector(':scope > .tc-panel');
    if (!panel) return;
    dd.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    // In a sideways-scrolling row, bring the button fully into view first.
    var row = dd.closest('.tc-bar__left');
    if (row && row.scrollWidth > row.clientWidth) {
      var br = btn.getBoundingClientRect(), rr = row.getBoundingClientRect();
      if (br.left < rr.left) row.scrollLeft -= (rr.left - br.left) + 8;
      else if (br.right > rr.right) row.scrollLeft += (br.right - rr.right) + 8;
    }
    placePanel(dd);
  }

  // Panels in the (sideways-scrolling) filter row are position: fixed on desktop,
  // placed under their button here. Others keep the plain right-edge check.
  function placePanel(dd) {
    var btn = dd.querySelector(':scope > .tc-btn');
    var panel = dd.querySelector(':scope > .tc-panel');
    if (!btn || !panel || panel.hidden) return;
    if (getComputedStyle(panel).position === 'fixed') {
      panel.style.top = '0px';
      panel.style.left = '0px';
      var origin = panel.getBoundingClientRect(); // corrects for any transformed parent
      var r = btn.getBoundingClientRect();
      var w = panel.offsetWidth;
      var left = r.left;
      if (left + w > window.innerWidth - 16) left = Math.max(16, r.right - w);
      panel.style.top = (r.bottom + 10 - origin.top) + 'px';
      panel.style.left = (left - origin.left) + 'px';
      return;
    }
    panel.style.top = '';
    panel.style.left = '';
    if (!dd.classList.contains('tc-dd--sort')) {
      panel.classList.remove('tc-panel--right');
      if (panel.getBoundingClientRect().right > window.innerWidth - 16) {
        panel.classList.add('tc-panel--right');
      }
    }
  }
  function placeOpenPanels() {
    document.querySelectorAll('.tc-dd.is-open').forEach(placePanel);
  }
  // Fade the right edge of the filter row while more buttons are hidden off it.
  function markOverflow() {
    document.querySelectorAll('.tc-bar__left').forEach(function (row) {
      var over = row.scrollWidth > row.clientWidth + 1;
      row.classList.toggle('is-overflow', over);
      row.classList.toggle('is-end', over && row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
    });
  }
  // Sticky filter row: sit just under the header (wherever its bottom edge is now),
  // match the page background, and show a soft shadow once it's stuck.
  var stickyQueued = false;
  function pageBg(el) {
    for (var n = el; n && n !== document.documentElement; n = n.parentElement) {
      var bg = getComputedStyle(n).backgroundColor;
      if (bg && bg !== 'transparent' && !/rgba\(\s*0,\s*0,\s*0,\s*0\s*\)/.test(bg)) return bg;
    }
    return '#fff';
  }
  function updateSticky() {
    stickyQueued = false;
    autoHideHeader();
    var top = headerBottom();
    document.documentElement.style.setProperty('--tc-sticky-top', top + 'px');
    document.querySelectorAll('.tc-bar__row').forEach(function (row) {
      if (!row.dataset.bg) { row.dataset.bg = '1'; row.style.setProperty('--tc-page-bg', pageBg(row.closest('.tc-bar').parentElement)); }
      // Desktop: the whole row sticks. Phones: only the button row inside it.
      var el = getComputedStyle(row).display !== 'contents' ? row : row.querySelector('.tc-bar__left');
      if (!el) return;
      var other = el === row ? row.querySelector('.tc-bar__left') : row;
      if (other) other.classList.remove('is-stuck');
      el.classList.toggle('is-stuck', window.scrollY > 0 && el.getBoundingClientRect().top <= top + 1);
    });
  }
  /* Phones: the header slides away while scrolling down (more room for the
   * products under the sticky filter buttons) and comes back on any scroll up.
   * Only on pages with the bar, and only when Theme settings → Filter bar →
   * "Hide the header while scrolling down" is on. */
  var HH = { hidden: false, lastY: 0, travel: 0 };
  function headerEl() { return document.querySelector('.header-section') || document.querySelector('.header'); }
  // Where the header's bottom edge sits once any slide has finished (0 when hidden).
  function headerBottom() {
    var h = headerEl();
    if (!h) return 0;
    if (HH.hidden) return 0;
    var r = h.getBoundingClientRect();
    var shift = 0;
    try { shift = new DOMMatrixReadOnly(getComputedStyle(h).transform).m42 || 0; } catch (e) {}
    return Math.max(0, Math.round(r.bottom - shift));
  }
  function setHeaderHidden(on) {
    if (HH.hidden === on) return;
    HH.hidden = on;
    document.documentElement.classList.toggle('tc-header-hidden', on);
  }
  function autoHideHeader() {
    var b = bar();
    var h = headerEl();
    var y = Math.max(0, window.scrollY);
    var dy = y - HH.lastY;
    HH.lastY = y;
    if (!b || !h || !b.hasAttribute('data-tc-hide-header') || !isMobile() ||
        document.documentElement.classList.contains('tc-drawer-open') ||
        document.body.classList.contains('overflow-hidden') || document.body.classList.contains('open-cc') ||
        document.querySelector('.tc-dd.is-open')) {
      HH.travel = 0;
      setHeaderHidden(false);
      return;
    }
    // Near the top of the page, the header always shows.
    if (y < h.offsetTop + h.offsetHeight + 120) { HH.travel = 0; setHeaderHidden(false); return; }
    // Small wobbles (a finger resting on the screen) don't flip it.
    if ((dy > 0) !== (HH.travel > 0)) HH.travel = 0;
    HH.travel += dy;
    if (HH.travel > 24) setHeaderHidden(true);
    else if (HH.travel < -12) setHeaderHidden(false);
  }
  TC.header = HH;

  function queueSticky() { if (!stickyQueued) { stickyQueued = true; requestAnimationFrame(updateSticky); } }
  // Phones/tablets: chips go right under the filter buttons, with the count and
  // Sort below them (just above the products). Desktop: chips under the whole row.
  function placeChips() {
    document.querySelectorAll('.tc-bar').forEach(function (barEl) {
      var row = barEl.querySelector('.tc-bar__row');
      var chips = barEl.querySelector('.tc-chips');
      var right = row && row.querySelector('.tc-bar__right');
      if (!row || !chips || !right) return;
      if (isMobile()) {
        if (chips.nextElementSibling !== right) row.insertBefore(chips, right);
      } else if (chips.parentElement === row) {
        row.parentNode.insertBefore(chips, row.nextSibling);
      }
    });
  }
  // Desktop: show two rows of chips, then "+N more"; "Show less" folds them again.
  TC.chipsOpen = false;
  function limitChips() {
    document.querySelectorAll('.tc-bar .tc-chips').forEach(function (box) {
      var old = box.querySelector('.tc-chips-more');
      if (old) old.remove();
      box.querySelectorAll('.tc-chip--over').forEach(function (el) { el.classList.remove('tc-chip--over'); });
      if (isMobile()) return;
      var clearAll = box.querySelector('.tc-clear-all');
      var clearWrap = clearAll ? clearAll.closest('facet-remove') || clearAll : null;
      var items = Array.prototype.filter.call(box.children, function (el) {
        return el !== clearWrap && !el.hidden && el.offsetParent !== null;
      });
      if (!items.length) return;
      // Rows by each item's vertical middle (links sit lower than chips on the same row).
      var mid = function (el) { return el.offsetTop + el.offsetHeight / 2; };
      var tops = [];
      items.forEach(function (el) {
        var m = mid(el);
        if (!tops.some(function (t) { return Math.abs(t - m) < 12; })) tops.push(m);
      });
      if (tops.length <= 2) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tc-link tc-clear-all tc-chips-more';
      box.insertBefore(btn, clearWrap);
      if (TC.chipsOpen) { btn.textContent = 'Show less'; return; }
      var row2 = tops.sort(function (a, b) { return a - b; })[1];
      var hidden = 0;
      var below = function (el) { return mid(el) > row2 + 12; };
      items.forEach(function (el) { if (below(el)) { el.classList.add('tc-chip--over'); hidden++; } });
      btn.textContent = '+' + hidden + ' more';
      // Make room for the button on row 2.
      var shown = items.filter(function (el) { return !el.classList.contains('tc-chip--over'); });
      while ((below(btn) || (clearAll && below(clearAll))) && shown.length > 1) {
        shown.pop().classList.add('tc-chip--over');
        hidden++;
        btn.textContent = '+' + hidden + ' more';
      }
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.tc-chips-more')) return;
    TC.chipsOpen = !TC.chipsOpen;
    limitChips();
  });
  window.addEventListener('resize', limitChips);
  document.addEventListener('facets:updated', function () { setTimeout(limitChips, 0); });
  if (document.readyState !== 'loading') setTimeout(limitChips, 0);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(limitChips, 0); });

  window.addEventListener('resize', placeChips);
  document.addEventListener('facets:updated', placeChips);
  if (document.readyState !== 'loading') placeChips();
  else document.addEventListener('DOMContentLoaded', placeChips);

  window.addEventListener('scroll', queueSticky, { passive: true });
  window.addEventListener('resize', queueSticky);
  document.addEventListener('facets:updated', queueSticky);
  if (document.readyState !== 'loading') queueSticky();
  else document.addEventListener('DOMContentLoaded', queueSticky);

  window.addEventListener('scroll', function () { placeOpenPanels(); markOverflow(); }, { passive: true, capture: true });
  window.addEventListener('resize', function () { placeOpenPanels(); markOverflow(); });
  document.addEventListener('facets:updated', markOverflow);
  if (document.readyState !== 'loading') markOverflow();
  else document.addEventListener('DOMContentLoaded', markOverflow);

  function filterList(find) {
    var q = find.value.trim().toLowerCase();
    var box = find.closest('.tc-dd, .tc-sec');
    // While searching, era headings are plain labels (no tick-all box, no count),
    // so a heading never selects sets the shopper can't see.
    box.classList.toggle('is-searching', q !== '');
    box.querySelectorAll('.tc-opt').forEach(function (opt) {
      var lab = opt.querySelector('.tc-opt__label');
      var name = (lab.firstChild && lab.firstChild.nodeType === 3 ? lab.firstChild.nodeValue : lab.textContent).toLowerCase();
      var direct = name.indexOf(q) !== -1 || (opt.dataset.code || '').toLowerCase().indexOf(q) !== -1;
      var text = name + ' ' + (opt.dataset.find || '');
      opt.hidden = q !== '' && text.indexOf(q) === -1;
      // Matched only through its English equivalent: say why it's here.
      var note = lab.querySelector('.tc-opt__note');
      var showNote = q !== '' && !opt.hidden && !direct && opt.dataset.english;
      if (showNote && !note) {
        note = document.createElement('span');
        note.className = 'tc-opt__note';
        lab.appendChild(note);
      }
      if (note) {
        note.textContent = showNote ? (opt.dataset.language ? opt.dataset.language + ' · ' : '') + 'cards from ' + opt.dataset.english : '';
        note.hidden = !showNote;
      }
    });
    // Hide a heading (era, Product Type section) when nothing under it matches.
    box.querySelectorAll('.tc-group').forEach(function (g) {
      g.hidden = q !== '' && !g.querySelector('.tc-opt:not([hidden])');
    });
    // Nothing matches: say so, named for the filter ("No sets found").
    var list = box.querySelector('.tc-list') || find.parentElement;
    var empty = list.querySelector(':scope > .tc-find-empty');
    var none = q !== '' && !box.querySelector('.tc-opt:not([hidden])');
    if (none && !empty) {
      empty = document.createElement('p');
      empty.className = 'tc-find-empty';
      empty.setAttribute('role', 'status');
      list.appendChild(empty);
    }
    if (empty) {
      empty.hidden = !none;
      if (none) empty.textContent = 'No ' + findNoun(box) + ' found';
    }
  }
  var FIND_NOUNS = { set: 'sets', product_type: 'product types', language: 'languages', card_type: 'card types',
    rarity: 'rarities', brand: 'brands', license: 'licenses', era: 'eras' };
  function findNoun(box) {
    var key = box.dataset.key || '';
    var btn = box.querySelector(':scope > .tc-btn');
    var label = (box.dataset.label || (btn ? btn.textContent : '')).replace(/\(\d+\)/, '').trim().toLowerCase();
    if (key === 'license' && (label === 'tcg' || label === 'game')) return 'games';
    return FIND_NOUNS[key] || 'matches';
  }

  // Remember the open dropdown when a choice is made, so it reopens after the
  // results (and the bar) are redrawn.
  document.addEventListener('input', function (e) {
    var t = e.target;
    // The "Find a set" box and price boxes must not submit the form on every keystroke.
    // Card search: nothing happens until Enter / Search.
    if (t.matches && t.matches('[data-tc-cs-input]')) { e.stopPropagation(); csSync(); return; }
    if (t.matches && (t.matches('.tc-find') || t.matches('[data-tc-price-input]'))) {
      e.stopPropagation();
      if (t.matches('.tc-find')) filterList(t);
      else clearPresets(t.closest('.tc-dd, .tc-sec'));
      return;
    }
    // A section heading's box (Product Type) ticks/unticks every option under it.
    if (t.matches && t.matches('[data-tc-group]')) {
      t.closest('.tc-group').querySelectorAll('input[type="checkbox"][name]:not(:disabled)').forEach(function (c) {
        c.checked = t.checked;
      });
    }
    var dd2 = t.closest && t.closest('.tc-dd.is-open');
    // A ticked option reaches the theme half a second later (it waits for more ticks), so
    // remember it: a refresh that finishes before then isn't the last one.
    if (t.name) TC.lastChange = Date.now();

    if (dd2) {
      var list = dd2.querySelector('.tc-list');
      var find = dd2.querySelector('.tc-find');
      TC.reopen = {
        key: dd2.dataset.key,
        find: find ? find.value : '',
        scroll: list ? list.scrollTop : 0,
        name: t.name || '',
        value: t.value || ''
      };
    }
  }, true);

  function markGroups(root) {
    (root || document).querySelectorAll('[data-tc-group][data-some]').forEach(function (el) { el.indeterminate = true; });
    disableEmptyGroups(root);
  }
  // A heading whose options are all greyed out (0 results, none ticked) can't be ticked either.
  function disableEmptyGroups(root) {
    (root || document).querySelectorAll('.tc-group').forEach(function (g) {
      var cb = g.querySelector(':scope > .tc-group__title [data-tc-group]');
      if (!cb) return;
      var empty = !g.querySelector('input[type="checkbox"][name]:not(:disabled)');
      cb.disabled = empty;
      cb.closest('.tc-group__title').classList.toggle('is-zero', empty);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { markGroups(); enhanceSets(); });
  if (document.readyState !== 'loading') enhanceSets();

  // A refresh in progress (a filter, sort or search is loading): the bar is about to be
  // replaced, so a dropdown opened now is reopened once the new bar is in.
  TC.pending = false;
  TC.inflight = 0;   // refreshes started but not finished (a second tick while one loads)
  var pendingTimer = null;
  function markPending() {
    TC.pending = true;
    TC.inflight++;
    TC.lastRender = Date.now();
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () { TC.pending = false; TC.inflight = 0; TC.reopen = null; }, 15000);
  }
  function watchRefresh() {
    if (typeof FacetFiltersForm === 'undefined' || !FacetFiltersForm.renderPage || FacetFiltersForm.renderPage.tcPending) return;
    var inner = FacetFiltersForm.renderPage;
    var outer = function () {
      markPending();
      TC.inRefresh = true;  // a card search started from here is the same refresh
      try { return inner.apply(FacetFiltersForm, arguments); } finally { TC.inRefresh = false; }
    };
    outer.tcPending = true;
    outer.tcWrapped = inner.tcWrapped;
    FacetFiltersForm.renderPage = outer;
  }
  TC.markPending = markPending;
  if (document.readyState === 'complete') setTimeout(watchRefresh, 0);
  else window.addEventListener('load', function () { setTimeout(watchRefresh, 0); });

  document.addEventListener('facets:updated', function () {
    TC.inflight = Math.max(0, TC.inflight - 1);
    // Another refresh is still on its way (an option ticked while this one loaded): keep
    // the dropdown's place so it opens again on that bar too.
    var more = TC.inflight > 0 || (TC.lastChange || 0) > (TC.lastRender || 0);
    if (!more) { TC.pending = false; clearTimeout(pendingTimer); }
    markGroups();
    fillBigLists(document);
    groupSetsNow(document);
    fillFullSets(document);
    enhanceSets();
    var r = TC.reopen;
    TC.reopen = more ? r : null;
    if (!r) return;
    var dd = document.querySelector('.tc-dd[data-key="' + r.key + '"]');
    if (!dd) return;
    open(dd);
    // Keep what was typed in "Find a …" so the narrowed list stays narrowed.
    var find = dd.querySelector('.tc-find');
    if (find && r.find) {
      find.value = r.find;
      filterList(find);
    }
    var list = dd.querySelector('.tc-list');
    if (list) list.scrollTop = r.scroll;
    if (r.name) {
      var input = dd.querySelector('input[name="' + CSS.escape(r.name) + '"][value="' + CSS.escape(r.value) + '"]');
      if (input) input.focus({ preventScroll: true });
    }
  });

  function applyPrice(dd) {
    dd.querySelectorAll('[data-tc-price-input]').forEach(function (input) {
      if (input.value !== '') input.name = input.dataset.name;
      else input.removeAttribute('name');
    });
    TC.reopen = null;
    closeAll();
    submit();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t.closest('.tc-dd > .tc-btn');
    if (btn && isMobile() && TC.openSheet && TC.openSheet(btn.parentElement.dataset.key, btn)) {
      closeAll();
      TC.reopen = null;
      return;
    }
    if (btn) {
      var dd = btn.parentElement;
      if (dd.classList.contains('is-open')) { closeAll(); TC.reopen = null; }
      else {
        open(dd);
        if (TC.pending) TC.reopen = { key: dd.dataset.key, find: '', scroll: 0, name: '', value: '', pendingOpen: true };
      }
      return;
    }
    var clear = t.closest('[data-tc-clear]');
    if (clear) {
      var ddc = clear.closest('.tc-dd');
      var changed = false;
      ddc.querySelectorAll('input[type="checkbox"]:checked').forEach(function (c) { c.checked = false; changed = true; });
      ddc.querySelectorAll('[data-tc-price-input]').forEach(function (i) {
        if (i.value !== '') changed = true;
        i.value = '';
        i.removeAttribute('name');
      });
      TC.reopen = null;
      closeAll();
      if (changed) submit();
      return;
    }
    var apply = t.closest('[data-tc-apply]');
    if (apply) { applyPrice(apply.closest('.tc-dd')); return; }
    var sortOpt = t.closest('[data-tc-sort-value]');
    if (sortOpt) {
      var f = form();
      f.querySelector('[data-tc-sort]').value = sortOpt.dataset.tcSortValue;
      TC.reopen = null;
      closeAll();
      submit();
      return;
    }
    // A click on the page itself (html/body) isn't a real "outside" click: during the theme's
    // page-swap animation every click lands there.
    if (t === document.documentElement || t === document.body) return;
    if (t.closest && t.closest('.loading-overlay')) return; // the theme's spinner layer
    if (!t.closest('.tc-dd')) { closeAll(); TC.reopen = null; }
  });

  // The theme animates each filter refresh with a View Transition. While one runs the page
  // can't be clicked (clicks land on <html>), so ticking a box mid-refresh closed the
  // dropdown and lost the tick. With a dropdown open, swap the results without the animation.
  if (typeof document.startViewTransition === 'function' && !document.startViewTransition.tcWrapped) {
    var vtOrig = document.startViewTransition.bind(document);
    var vt = function (arg) {
      if (document.querySelector('.tc-dd.is-open')) {
        var cb = typeof arg === 'function' ? arg : (arg && arg.update);
        try { if (cb) cb(); } catch (err) { if (window.console) console.error(err); }
        var done = Promise.resolve();
        return { finished: done, ready: done, updateCallbackDone: done, skipTransition: function () {} };
      }
      return vtOrig(arg);
    };
    vt.tcWrapped = true;
    document.startViewTransition = vt;
  }

  // Enter in a text box would submit the form and reload the page; the bar
  // applies through the theme's filter script instead.
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'TcFilterForm') e.preventDefault();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var dd = document.querySelector('.tc-dd.is-open');
      if (dd) {
        closeAll();
        TC.reopen = null;
        var b = dd.querySelector(':scope > .tc-btn');
        if (b) b.focus();
      }
      return;
    }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-tc-price-input]')) {
      e.preventDefault();
      applyPrice(e.target.closest('.tc-dd'));
      return;
    }
    // "All Filters" is the theme's <facet-toggle>; make it work from the keyboard too.
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.tc-btn--all')) {
      e.preventDefault();
      e.target.click();
    }
  });

  /* ---------------- All Filters drawer (step 2) ----------------
   * Nothing applies until "View [N] products". Each change in the drawer asks
   * the store for the page with those choices (without applying them) and
   * swaps in the updated sections and count. View applies through the theme's
   * filter script, like the bar.
   */
  var D = TC.drawer = { el: null, home: null, original: '', seq: 0, timer: null, lastFocus: null };

  function drawerForm() { return D.el ? D.el.querySelector('[data-tc-drawer-body]') : null; }

  function drawerParams() {
    var f = drawerForm();
    var params = new URLSearchParams();
    if (!f) return params;
    new FormData(f).forEach(function (v, k) {
      if (v === '' && k.indexOf('filter.v.price') === 0) return;
      params.append(k, v);
    });
    return params;
  }

  function openDrawer(trigger, only) {
    var el = document.querySelector('[data-tc-drawer]');
    if (!el) return false;
    if (only && !el.querySelector('.tc-sec[data-key="' + only + '"]')) return false;
    D.el = el;
    D.only = only || null;
    el.classList.toggle('tc-drawer--sheet', !!only);
    // Sort sheet (phones): tapping an option applies it, so there's no footer.
    el.classList.toggle('tc-drawer--sort', only === 'sort');
    // Move it to <body> while open so nothing on the page can clip it.
    D.home = document.createComment('tc-drawer');
    el.parentNode.insertBefore(D.home, el);
    document.body.appendChild(el);
    fillBigLists(el);
    groupSetsNow(el);
    fillFullSets(el);
    collapseChips(el, 'drawer', drawerRoots(el));
    D.original = drawerForm().innerHTML;
    D.start = drawerParams().toString();
    drawerFoot();
    D.lastFocus = trigger || document.activeElement;
    el.hidden = false;
    document.documentElement.classList.add('tc-drawer-open');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    var b = document.querySelector('[data-tc-drawer-open]');
    if (b) b.setAttribute('aria-expanded', 'true');
    applyOnly();
    markGroups(el);
    var x = el.querySelector('.tc-drawer__x');
    if (x) x.focus();
    return true;
  }

  // Bottom sheet = the drawer showing just one filter (mobile).
  TC.openSheet = function (key, trigger) { return openDrawer(trigger, key); };

  function applyOnly() {
    if (!D.el) return;
    var title = D.el.querySelector('.tc-drawer__title');
    D.el.querySelectorAll('.tc-sec').forEach(function (sec) {
      var on = D.only && sec.dataset.key === D.only;
      sec.classList.toggle('is-only', !!on);
      if (on) {
        sec.open = true;
        if (title) title.textContent = sec.dataset.title || ('Filter by ' + sec.dataset.label);
      }
    });
    if (!D.only && title) title.textContent = title.dataset.default || 'Filters';
  }

  function closeDrawer(applied) {
    if (!D.el) return;
    var el = D.el;
    clearTimeout(D.timer);
    D.seq++;
    el.classList.remove('is-open', 'tc-drawer--sheet', 'tc-drawer--sort');
    el.hidden = true;
    var title = el.querySelector('.tc-drawer__title');
    if (title) title.textContent = title.dataset.default || 'Filters';
    document.documentElement.classList.remove('tc-drawer-open');
    if (applied) {
      // The page re-renders with a fresh drawer; drop this one.
      el.remove();
      if (D.home) D.home.remove();
    } else {
      // Not applied: put back what was there before.
      drawerForm().innerHTML = D.original;
      if (D.home && D.home.parentNode) {
        D.home.parentNode.insertBefore(el, D.home);
        D.home.remove();
      }
      // The restored copy may be from before the full Set list arrived.
      Promise.resolve().then(function () { fillFullSets(el); });
      var b = document.querySelector('[data-tc-drawer-open]');
      if (b) b.setAttribute('aria-expanded', 'false');
      if (D.lastFocus && D.lastFocus.focus) D.lastFocus.focus();
    }
    D.el = null;
    D.home = null;
    D.only = null;
  }

  function snapshot(el) {
    var body = el.querySelector('[data-tc-drawer-body]');
    var snap = { scroll: body.scrollTop, open: {}, find: {}, lists: {}, view: el.querySelector('[data-tc-drawer-apply]').innerHTML };
    el.querySelectorAll('.tc-sec').forEach(function (sec) {
      var k = sec.dataset.key;
      snap.open[k] = sec.open;
      var find = sec.querySelector('.tc-find');
      if (find) snap.find[k] = find.value;
      var list = sec.querySelector('.tc-list');
      if (list) snap.lists[k] = list.scrollTop;
    });
    return snap;
  }

  function restoreView(el, snap) {
    if (!snap) return;
    el.querySelectorAll('.tc-sec').forEach(function (sec) {
      var k = sec.dataset.key;
      if (k in snap.open) sec.open = snap.open[k];
      var find = sec.querySelector('.tc-find');
      if (find && snap.find[k]) { find.value = snap.find[k]; filterList(find); }
      var list = sec.querySelector('.tc-list');
      if (list && snap.lists[k]) list.scrollTop = snap.lists[k];
    });
    el.querySelector('[data-tc-drawer-body]').scrollTop = snap.scroll;
    if (snap.view) el.querySelector('[data-tc-drawer-apply]').innerHTML = snap.view;
    markGroups(el);
  }

  function preview(focusTarget) {
    if (!D.el) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var seq = ++D.seq;
    var params = drawerParams();
    var useCs = CS.big ? bigNorm(params) : !!(CS.on && params.get('q'));
    if (useCs) CS.cur = csParams(params);
    var url = useCs ? csUrl(csParams(params), true) :
      window.location.pathname + '?section_id=' + encodeURIComponent(grid.dataset.id) + (params.toString() ? '&' + params.toString() : '');
    D.el.classList.add('is-loading');
    var focus = focusTarget && focusTarget.name ? { name: focusTarget.name, value: focusTarget.value } : null;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (seq !== D.seq || !D.el) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-tc-drawer]');
        if (!fresh) return;
        var snap = snapshot(D.el);
        snap.view = null;
        drawerForm().innerHTML = fresh.querySelector('[data-tc-drawer-body]').innerHTML;
        csDecorate(D.el);
        D.el.querySelector('[data-tc-drawer-apply]').innerHTML = fresh.querySelector('[data-tc-drawer-apply]').innerHTML;
        groupSetsNow(D.el);
        fillFullSets(D.el);
        collapseChips(D.el, 'drawer', drawerRoots(D.el));
        restoreView(D.el, snap);
        applyOnly();
        drawerFoot();
        if (focus) {
          var input = D.el.querySelector('input[name="' + CSS.escape(focus.name) + '"][value="' + CSS.escape(focus.value) + '"]');
          if (input) input.focus({ preventScroll: true });
        }
      })
      .catch(function () {})
      .then(function () { if (seq === D.seq && D.el) D.el.classList.remove('is-loading'); });
  }

  // Footer buttons: Clear is off when there's nothing to clear; View is off until
  // something has changed since the drawer opened.
  function drawerFoot() {
    if (!D.el) return;
    var clear = D.el.querySelector('[data-tc-drawer-clear]');
    var view = D.el.querySelector('[data-tc-drawer-apply]');
    var scope = D.only ? D.el.querySelector('.tc-sec[data-key="' + D.only + '"]') : drawerForm();
    var any = false;
    if (scope) {
      var shown = function (el) {
        var sec = el.closest('.tc-sec');
        return !sec || !(sec.hidden || sec.style.display === 'none');
      };
      if (D.only === 'sort') {
        var first = scope.querySelector('input[name="sort_by"]');
        any = !!(first && !first.checked);
      } else {
        any = Array.prototype.some.call(scope.querySelectorAll('input[type="checkbox"][name]:checked'), shown) ||
          Array.prototype.some.call(scope.querySelectorAll('[data-tc-price-input]'), function (i) { return i.value !== ''; });
        if (!any && !D.only) {
          any = Array.prototype.some.call(scope.querySelectorAll('input[type="hidden"][name^="filter."]:not([data-tc-keep])'), function (h) {
            return !(typeof csIsScope === 'function' && CS.on && csIsScope(h.name, h.value));
          });
        }
      }
    }
    if (clear) clear.disabled = !any;
    if (view) {
      // 0 results: "No matching products", and it can't be pressed.
      var countEl = view.querySelector('[data-tc-view-count]');
      var zero = !!countEl && parseInt(countEl.textContent, 10) === 0;
      view.classList.toggle('is-none', zero);
      view.disabled = zero || drawerParams().toString() === D.start;
    }
  }

  function schedulePreview(target) {
    drawerFoot();
    clearTimeout(D.timer);
    D.timer = setTimeout(function () { preview(target); }, 250);
  }

  // X, Esc and clicking outside keep the shopper's picks: apply if anything
  // changed, otherwise just close.
  function dismissDrawer() {
    if (!D.el) return;
    if (drawerParams().toString() !== D.start) applyDrawer();
    else closeDrawer(false);
  }

  function applyDrawer() {
    var params = drawerParams().toString();
    closeDrawer(true);
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(params);
    } else {
      window.location.search = params;
    }
  }

  // Changes inside the drawer: refresh the preview (the bar's own listeners
  // never see these, because the drawer isn't inside the bar's form).
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!D.el || !D.el.contains(t)) return;
    if (t.matches('.tc-find')) return;
    if (D.only === 'sort' && t.name === 'sort_by') { applyDrawer(); return; }
    if (t.matches('[data-tc-price-input]')) {
      if (t.value !== '') t.name = t.dataset.name; else t.removeAttribute('name');
    }
    if (t.matches('[data-tc-group]')) {
      t.closest('.tc-group').querySelectorAll('input[type="checkbox"][name]:not(:disabled)').forEach(function (c) { c.checked = t.checked; });
    }
    syncGroupBoxes(D.el);
    schedulePreview(t);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var openBtn = t.closest('[data-tc-drawer-open]');
    if (openBtn) { e.preventDefault(); closeAll(); TC.reopen = null; openDrawer(openBtn); return; }
    if (!D.el || !D.el.contains(t)) return;
    if (t.closest('[data-tc-drawer-close]')) { dismissDrawer(); return; }
    if (t.closest('[data-tc-drawer-apply]')) { if (!t.closest('[data-tc-drawer-apply]').disabled) applyDrawer(); return; }
    if (t.closest('[data-tc-drawer-clear]')) {
      // In a bottom sheet, Clear only clears that one filter.
      var scope = D.only ? D.el.querySelector('.tc-sec[data-key="' + D.only + '"]') : D.el.querySelector('[data-tc-drawer-body]');
      scope.querySelectorAll('input[type="checkbox"]').forEach(function (c) { c.checked = false; });
      if (D.only === 'sort') {
        var firstSort = scope.querySelector('input[name="sort_by"]');
        if (firstSort) firstSort.checked = true;
      }
      if (!D.only) {
        scope.querySelectorAll('input[type="hidden"]:not([data-tc-keep])').forEach(function (h) {
          if (h.name && h.name.indexOf('filter.') === 0) h.remove();
        });
      }
      scope.querySelectorAll('[data-tc-price-input]').forEach(function (i) { i.value = ''; i.removeAttribute('name'); });
      schedulePreview(null);
      return;
    }
    var chip = t.closest('[data-tc-uncheck-name]');
    if (chip) {
      var input = D.el.querySelector('input[name="' + CSS.escape(chip.dataset.tcUncheckName) + '"][value="' + CSS.escape(chip.dataset.tcUncheckValue) + '"]');
      if (input) input.checked = false;
      else D.el.querySelectorAll('input[type="hidden"][name="' + CSS.escape(chip.dataset.tcUncheckName) + '"]').forEach(function (h) { if (h.value === chip.dataset.tcUncheckValue) h.remove(); });
      schedulePreview(null);
      return;
    }
    if (t.closest('[data-tc-clear-price]')) {
      D.el.querySelectorAll('[data-tc-price-input]').forEach(function (i) { i.value = ''; i.removeAttribute('name'); });
      D.el.querySelectorAll('input[type="hidden"][name^="filter.v.price"]').forEach(function (h) { h.remove(); });
      schedulePreview(null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!D.el) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); dismissDrawer(); return; }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-tc-price-input]')) {
      e.preventDefault();
      var t = e.target;
      if (t.value !== '') t.name = t.dataset.name; else t.removeAttribute('name');
      schedulePreview(t);
      return;
    }
    if (e.key === 'Tab') {
      // Keep keyboard focus inside the drawer while it's open.
      var items = Array.prototype.filter.call(
        D.el.querySelectorAll('button, summary, input:not([type="hidden"]):not(:disabled), a[href]'),
        function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'TcDrawerForm') e.preventDefault();
  }, true);

  /* ---------------- Step 4: Set list by era ----------------
   * Set Info (era, release date, game) comes from a small data page,
   * /collections/all?view=custom-set-info-data (templates/collection.custom-set-info-data.liquid),
   * loaded once and remembered for 6 hours. The Set list is then regrouped
   * under era headings, newest first:
   *   - an era heading's box ticks every set under it (all in the Set filter,
   *     so picks in different eras add up);
   *   - "[Era] – Other" sets become "Other [Era] products" at the end of the era;
   *   - other games' sets (One Piece) sit under the game's name, no box;
   *   - sets with no Set Info entry go under "Other sets" at the end;
   *   - a fully ticked era shows as one chip, "Set: All Scarlet & Violet".
   * If Set Info can't be loaded, the list just stays alphabetical.
   */
  var SETINFO_KEY = 'tcSetInfo:v3'; // same key as the Shop by Set page
  var SETINFO_TTL = 6 * 60 * 60 * 1000;
  var setIndex = null, setIndexLoading = null;

  function norm(v) {
    return String(v || '').normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function firstVal(v) {
    if (Array.isArray(v)) return v[0] || '';
    if (typeof v === 'string' && v.charAt(0) === '[') {
      try { var a = JSON.parse(v); return Array.isArray(a) ? (a[0] || '') : v; } catch (e) {}
    }
    return v || '';
  }
  function buildIndex(sets) {
    var by = {};
    (sets || []).forEach(function (e) {
      if (!e || !e.set) return;
      var o = { set: e.set, era: firstVal(e.era), license: firstVal(e.license), date: e.date || '',
                code: e.code || '', english: e.english || '', language: firstVal(e.language) || '',
                url: e.url || '', count: e.count || 0,
                find: [e.code || '', e.english || ''].join(' ').toLowerCase() };
      if (!by[norm(o.set)]) by[norm(o.set)] = o;
      String(e.aliases || '').split(',').forEach(function (a) { a = norm(a); if (a && !by[a]) by[a] = o; });
    });
    return by;
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function fetchSetPage(n, acc) {
    return fetch(root() + 'collections/all?view=custom-set-info-data&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d = JSON.parse(t.trim());
        acc = acc.concat(d.sets || []);
        return (d.page < d.pages && n < 20) ? fetchSetPage(n + 1, acc) : acc;
      });
  }
  function loadSetIndex() {
    if (setIndex) return Promise.resolve(setIndex);
    if (setIndexLoading) return setIndexLoading;
    // In the theme editor, always load fresh (Set Info changes show on reload).
    var editor = !!(window.Shopify && Shopify.designMode);
    try {
      var c = JSON.parse(localStorage.getItem(SETINFO_KEY) || 'null');
      if (!editor && c && c.sets && Date.now() - c.t < SETINFO_TTL) { setIndex = buildIndex(c.sets); return Promise.resolve(setIndex); }
    } catch (e) {}
    setIndexLoading = fetchSetPage(1, []).then(function (sets) {
      try { localStorage.setItem(SETINFO_KEY, JSON.stringify({ t: Date.now(), sets: sets })); } catch (e) {}
      setIndex = buildIndex(sets);
      return setIndex;
    }).catch(function () { setIndexLoading = null; return null; });
    return setIndexLoading;
  }

  function syncGroupBoxes(scope) {
    (scope || document).querySelectorAll('.tc-group').forEach(function (g) {
      var cb = g.querySelector('[data-tc-group]');
      if (!cb) return;
      var boxes = Array.prototype.filter.call(g.querySelectorAll('input[type="checkbox"][name]'), function (c) { return !c.disabled || c.checked; });
      var on = boxes.filter(function (c) { return c.checked; }).length;
      cb.checked = boxes.length > 0 && on === boxes.length;
      cb.indeterminate = on > 0 && on < boxes.length;
    });
  }

  function cmpDateDesc(a, b) { return a > b ? -1 : a < b ? 1 : 0; }

  function groupSetList(list) {
    if (!list || !setIndex || list.dataset.tcGrouped) return;
    var opts = Array.prototype.slice.call(list.querySelectorAll('.tc-opt'));
    if (!opts.length) return;
    var groups = {}, known = 0;
    opts.forEach(function (opt) {
      var labelEl = opt.querySelector('.tc-opt__label');
      var name = labelEl.textContent.trim();
      var item = { opt: opt, name: name, date: '', other: false };
      var key, title, kind;
      var m = name.match(/^(.*\S)\s+[–-]\s+Other$/);
      var e = setIndex[norm(name)];
      if (m) {
        key = 'era:' + norm(m[1]); title = m[1]; kind = 'era'; item.other = true;
        labelEl.textContent = 'Other ' + m[1];
        known++;
      } else if (e) {
        var lic = norm(e.license);
        if (lic && lic !== 'pokemon') { key = 'game:' + lic; title = e.license; kind = 'game'; }
        else if (e.era) { key = 'era:' + norm(e.era); title = e.era; kind = 'era'; }
        else { key = 'zz'; title = 'Other sets'; kind = 'other'; }
        item.date = e.date;
        if (e.find.trim()) opt.dataset.find = e.find;
        if (e.code) opt.dataset.code = e.code;
        if (e.english) opt.dataset.english = e.english;
        if (e.language) opt.dataset.language = e.language;
        known++;
      } else { key = 'zz'; title = 'Other sets'; kind = 'other'; }
      if (!groups[key]) groups[key] = { title: title, kind: kind, items: [], newest: '' };
      groups[key].items.push(item);
      if (item.date > groups[key].newest) groups[key].newest = item.date;
    });
    if (!known) return;
    var rank = { era: 0, game: 1, other: 2 };
    var ordered = Object.keys(groups).map(function (k) { return groups[k]; }).sort(function (a, b) {
      return (rank[a.kind] - rank[b.kind]) || cmpDateDesc(a.newest, b.newest) || a.title.localeCompare(b.title);
    });
    var frag = document.createDocumentFragment();
    ordered.forEach(function (g) {
      g.items.sort(function (a, b) {
        // Sets with results first, then 0-result sets (greyed); each in release order.
        var za = a.opt.classList.contains('is-zero') ? 1 : 0, zb = b.opt.classList.contains('is-zero') ? 1 : 0;
        return (za - zb) || (a.other - b.other) || cmpDateDesc(a.date, b.date) || a.name.localeCompare(b.name);
      });
      var wrap = document.createElement('div');
      wrap.className = 'tc-group tc-group--era';
      wrap.dataset.era = g.title;
      var head = document.createElement(g.kind === 'era' ? 'label' : 'div');
      head.className = 'tc-group__title' + (g.kind === 'era' ? '' : ' is-plain');
      if (g.kind === 'era') {
        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.setAttribute('data-tc-group', '');
        head.appendChild(cb);
      }
      var nm = document.createElement('span');
      nm.className = 'tc-group__name';
      nm.textContent = g.title;
      head.appendChild(nm);
      var total = 0;
      g.items.forEach(function (it) { total += parseInt((it.opt.querySelector('.tc-opt__count') || {}).textContent, 10) || 0; });
      var ct = document.createElement('span');
      ct.className = 'tc-opt__count';
      ct.textContent = total;
      head.appendChild(ct);
      wrap.appendChild(head);
      g.items.forEach(function (it) { it.opt.classList.add('tc-opt--indent'); wrap.appendChild(it.opt); });
      frag.appendChild(wrap);
    });
    list.innerHTML = '';
    list.appendChild(frag);
    list.dataset.tcGrouped = '1';
    disableEmptyGroups(list);
    syncGroupBoxes(list);
  }

  /* Collections over 5,000 products (Singles, Singles Under $10): Shopify sends no
   * filters, so the bar has a Set filter of its own ([data-tc-big-list], from
   * custom-filter-bar.liquid). Its options are every set in Set Info, grouped like the
   * real list, with no counts. Picking one shows the matching singles from search
   * (card search with no term, see "big mode" below), and the bar becomes the real one.
   */
  function fillBigLists(scope) {
    if (!setIndex) return;
    (scope || document).querySelectorAll('[data-tc-big-list]:not([data-tc-filled])').forEach(function (list) {
      var name = list.getAttribute('data-name');
      var on = (list.getAttribute('data-on') || '').split('\n');
      // Only sets with singles here: a Singles collection (Set Info) that has products,
      // and on a one-language page (data-lang) only that language's sets.
      var lang = norm(list.getAttribute('data-lang') || '');
      var seen = [];
      var html = '';
      Object.keys(setIndex).forEach(function (k) {
        var e = setIndex[k];
        if (seen.indexOf(e) !== -1) return;
        seen.push(e);
        if (!e.url || !(e.count > 0)) return;
        if (lang && norm(e.language || 'English') !== lang) return;
        var ck = on.indexOf(e.set) !== -1;
        html += '<label class="tc-opt' + (ck ? ' is-on' : '') + '"><input type="checkbox" name="' + escHtml(name) + '" value="' + escHtml(e.set) + '"' + (ck ? ' checked' : '') + '>' +
          '<span class="tc-opt__label">' + escHtml(e.set) + '</span></label>';
      });
      list.innerHTML = html;
      list.setAttribute('data-tc-filled', '');
    });
  }

  function groupSetsNow(scope) {
    if (!setIndex) return;
    (scope || document).querySelectorAll('[data-key="set"] .tc-list').forEach(groupSetList);
  }

  /* Full Set list. Shopify's Set filter shows at most 100 sets for the WHOLE store, so
   * most pages are missing some of their sets. On collection pages up to 2,500 products
   * the Set list is marked [data-tc-set-full] (custom-filter-bar.liquid) and rebuilt here
   * from /collections/<handle>?view=custom-set-list (templates/collection.custom-set-list
   * .liquid): every product's Set, with the page's other filters applied, so the counts
   * work like Shopify's (a ticked set doesn't change the other sets' counts).
   * Ticking a set still uses Shopify's own filter, which works for every set.
   * A Set filter Shopify alone wouldn't show ([data-tc-set-wait]) stays hidden until
   * 2+ sets are found.
   */
  var SETFULL_NAME = 'filter.p.m.custom.filter_set_name';
  var SETFULL_PAGES = 10;   // 250 products a page
  var setFullCache = {};
  var setFullBusy = typeof WeakSet === 'function' ? new WeakSet() : null;

  function setFullQuery(params) {
    var q = new URLSearchParams();
    params.forEach(function (v, k) {
      if (k.indexOf('filter.') !== 0 || k === SETFULL_NAME) return;
      if (v === '' && k.indexOf('filter.v.price') === 0) return;
      q.append(k, v);
    });
    q.sort();
    return q.toString();
  }

  function setFullLoad(query) {
    if (setFullCache[query]) return setFullCache[query];
    var base = window.location.pathname + '?view=custom-set-list' + (query ? '&' + query : '');
    var get = function (n) {
      return fetch(base + '&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t.trim()); });
    };
    var p = get(1).then(function (first) {
      var more = [];
      for (var n = 2; n <= Math.min(first.pages || 1, SETFULL_PAGES); n++) more.push(get(n));
      return Promise.all(more).then(function (rest) {
        var counts = {};
        [first].concat(rest).forEach(function (d) {
          (d.sets || []).forEach(function (v) {
            (Array.isArray(v) ? v : [v]).forEach(function (s) {
              s = String(s || '').trim();
              if (s) counts[s] = (counts[s] || 0) + 1;
            });
          });
        });
        return counts;
      });
    });
    p.catch(function () { delete setFullCache[query]; });
    setFullCache[query] = p;
    return p;
  }

  function fillFullSets(scope) {
    (scope || document).querySelectorAll('[data-tc-set-full]:not([data-tc-full-done])').forEach(function (list) {
      // The drawer while open counts with its pending choices; everywhere else, what's applied.
      var inDrawer = !!(D.el && D.el.contains(list));
      var f = form();
      var params = inDrawer ? drawerParams() : (f ? new FormData(f) : new URLSearchParams(window.location.search));
      if (setFullBusy) { if (setFullBusy.has(list)) return; setFullBusy.add(list); }
      setFullLoad(setFullQuery(params)).then(function (counts) {
        if (setFullBusy) setFullBusy.delete(list);
        if (list.isConnected && !list.hasAttribute('data-tc-full-done')) buildFullSetList(list, counts);
      }).catch(function () {
        // Couldn't load: Shopify's own list stays (a hidden Set filter stays hidden).
        if (setFullBusy) setFullBusy.delete(list);
      });
    });
  }

  function buildFullSetList(list, counts) {
    var name = list.getAttribute('data-name') || SETFULL_NAME;
    var on = [];
    list.querySelectorAll('input[type="checkbox"][name="' + CSS.escape(name) + '"]:checked').forEach(function (i) {
      if (on.indexOf(i.value) === -1) on.push(i.value);
    });
    var names = Object.keys(counts);
    on.forEach(function (v) { if (names.indexOf(v) === -1) names.push(v); });
    names.sort(function (a, b) { return a.localeCompare(b); });
    var html = '';
    names.forEach(function (s) {
      var n = counts[s] || 0;
      var ck = on.indexOf(s) !== -1;
      var zero = n === 0 && !ck;
      html += '<label class="tc-opt' + (ck ? ' is-on' : '') + (zero ? ' is-zero' : '') + '">' +
        '<input type="checkbox" name="' + escHtml(name) + '" value="' + escHtml(s) + '"' + (ck ? ' checked' : '') + (zero ? ' disabled' : '') + '>' +
        '<span class="tc-opt__label">' + escHtml(s) + '</span><span class="tc-opt__count">' + n + '</span></label>';
    });
    list.innerHTML = '<div class="tc-group">' + html + '</div>';
    delete list.dataset.tcGrouped;
    list.setAttribute('data-tc-full-done', '');
    var live = names.filter(function (s) { return counts[s] > 0 || on.indexOf(s) !== -1; }).length;
    var box = list.closest('.tc-dd, .tc-sec');
    if (box) {
      if (box.hasAttribute('data-tc-set-wait')) {
        var show = live >= 2 || on.length > 0;
        box.hidden = !show;
        box.style.display = show ? '' : 'none';
      }
      // "Find a set" and the drawer's scroll box only for long lists, like the others.
      var find = box.querySelector('.tc-find');
      if (find && !find.value) {
        find.hidden = names.length <= 12;
        find.style.display = names.length <= 12 ? 'none' : '';
      }
      if (box.classList.contains('tc-sec')) list.classList.toggle('tc-list--box', names.length > 12);
    }
    if (setIndex) groupSetList(list);
    else { disableEmptyGroups(list); syncGroupBoxes(list); }
    var barEl = bar();
    if (barEl) collapseChips(barEl, 'bar', barRoots());
    if (D.el) collapseChips(D.el, 'drawer', drawerRoots(D.el));
    limitChips();
    markOverflow();
    placeOpenPanels();
  }

  // A fully ticked group shows as one chip: an era in Set ("Set: All Mega
  // Evolution") or a Product Type section ("Type: All Cards & Sealed").
  // mode 'bar' (applied filters, links) or 'drawer' (pending choices, buttons).
  var ROLLUPS = [
    { key: 'set', param: 'filter_set_name', prefix: 'Set', groups: '.tc-group--era' },
    { key: 'product_type', param: 'product_type', prefix: 'Type', groups: '.tc-group' }
  ];
  function escHtml(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }

  function collapseKind(scope, root, mode, cfg) {
    var attrN = mode === 'bar' ? 'data-tc-chip-name' : 'data-tc-uncheck-name';
    var attrV = mode === 'bar' ? 'data-tc-chip-value' : 'data-tc-uncheck-value';
    scope.querySelectorAll('[data-tc-era-chip][data-kind="' + cfg.key + '"]').forEach(function (c) { c.remove(); });
    var chips = Array.prototype.slice.call(scope.querySelectorAll((mode === 'bar' ? 'facet-remove' : 'button') + '[' + attrN + '*="' + cfg.param + '"]'));
    chips.forEach(function (c) { c.hidden = false; });
    if (!chips.length) return null;
    var rolled = 0;
    if (root) root.querySelectorAll(cfg.groups).forEach(function (g) {
      var cb = g.querySelector('[data-tc-group]');
      if (!cb || !cb.checked) return;
      var inputs = Array.prototype.slice.call(g.querySelectorAll('input[type="checkbox"][name]:checked'));
      if (!inputs.length) return;
      var keys = inputs.map(function (i) { return i.name + '\n' + i.value; });
      var mine = chips.filter(function (c) { return !c.hidden && keys.indexOf(c.getAttribute(attrN) + '\n' + c.getAttribute(attrV)) !== -1; });
      if (mine.length < 2) return;
      mine.forEach(function (c) { c.hidden = true; });
      var nameEl = g.querySelector('.tc-group__name');
      var title = g.dataset.era || (nameEl ? nameEl.textContent.trim() : '');
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'tc-chip';
      chip.setAttribute('data-tc-era-chip', mode);
      chip.dataset.kind = cfg.key;
      chip.dataset.name = inputs[0].name;
      chip.dataset.values = JSON.stringify(inputs.map(function (i) { return i.value; }));
      chip.setAttribute('aria-label', 'Remove ' + cfg.prefix + ': All ' + title);
      chip.innerHTML = '<span class="tc-chip__group">' + cfg.prefix + ':</span> All ' + escHtml(title) +
        ' <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      mine[0].parentNode.insertBefore(chip, mine[0]);
      rolled++;
    });
    var visible = chips.filter(function (c) { return !c.hidden; }).length + rolled;
    if (rolled) {
      // The filter's count is the number of chips (a whole group counts as 1).
      var host = mode === 'bar' ? document.querySelector('.tc-dd[data-key="' + cfg.key + '"] [data-tc-label]') : scope.querySelector('.tc-sec[data-key="' + cfg.key + '"] [data-tc-label]');
      if (host) {
        var base = host.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
        host.innerHTML = mode === 'bar' ? escHtml(base) + ' (' + visible + ')' : escHtml(base) + ' <span class="tc-sec__value">(' + visible + ')</span>';
      }
    }
    return [chips.length, visible];
  }

  // roots: where to read each filter's groups from ({ set: el, product_type: el }).
  function collapseChips(scope, mode, roots) {
    if (!scope) return;
    var before = 0, after = 0;
    ROLLUPS.forEach(function (cfg) {
      var r = collapseKind(scope, roots[cfg.key], mode, cfg);
      if (r) { before += r[0]; after += r[1]; }
    });
    // All Filters count: a whole group counts as 1 there too.
    if (mode === 'bar') {
      var tot = document.querySelector('.tc-bar [data-tc-total]');
      if (tot) {
        var n = (parseInt(tot.getAttribute('data-n'), 10) || 0) - before + after;
        tot.textContent = n > 0 ? ' (' + n + ')' : '';
      }
    }
  }
  function drawerRoots(el) {
    return { set: el.querySelector('.tc-sec[data-key="set"]'), product_type: el.querySelector('.tc-sec[data-key="product_type"]') };
  }
  function barRoots() {
    var drawerEl = !D.el ? document.querySelector('[data-tc-drawer]') : null;
    var pick = function (k) {
      return document.querySelector('.tc-bar .tc-dd[data-key="' + k + '"]') ||
        (drawerEl ? drawerEl.querySelector('.tc-sec[data-key="' + k + '"]') : null);
    };
    return { set: pick('set'), product_type: pick('product_type') };
  }

  function enhanceSets() {
    var run = function () {
      var barEl = bar();
      if (barEl) collapseChips(barEl, 'bar', barRoots());
      if (D.el) collapseChips(D.el, 'drawer', drawerRoots(D.el));
      limitChips(); // roll-ups change how many chips there are
    };
    // Product Type roll-ups don't need the set list. (Deferred: this can be
    // called before the rest of the script has finished loading.)
    Promise.resolve().then(run);
    Promise.resolve().then(function () { fillFullSets(document); });
    loadSetIndex().then(function (idx) {
      if (!idx) return;
      fillBigLists(document);
      groupSetsNow(document);
      run();
    });
  }

  /* ---------------- Step 4: price presets + Under $10 toggle ---------------- */
  function clearPresets(box) {
    if (!box) return;
    box.querySelectorAll('[data-tc-preset]').forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
  }

  function priceParams(params, gte, lte, min, max) {
    params.delete(gte); params.delete(lte);
    if (min !== '') params.set(gte, min);
    if (max !== '') params.set(lte, max);
    return params;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var preset = t.closest('[data-tc-preset]');
    if (preset) {
      var box = preset.closest('.tc-dd, .tc-sec');
      var inputs = box.querySelectorAll('[data-tc-price-input]');
      var vals = [preset.dataset.min, preset.dataset.max];
      inputs.forEach(function (input, i) {
        input.value = vals[i] || '';
        if (input.value !== '') input.name = input.dataset.name; else input.removeAttribute('name');
      });
      clearPresets(box);
      preset.classList.add('is-on');
      preset.setAttribute('aria-pressed', 'true');
      if (D.el && D.el.contains(preset)) { schedulePreview(null); }
      else { TC.reopen = null; closeAll(); submit(); }
      return;
    }

    var u10 = t.closest('[data-tc-under10]');
    if (u10) {
      var f = form();
      if (!f) return;
      var params = new URLSearchParams();
      new FormData(f).forEach(function (v, k) { if (!(v === '' && k.indexOf('filter.v.price') === 0)) params.append(k, v); });
      var on = u10.getAttribute('aria-pressed') === 'true';
      priceParams(params, u10.dataset.gte, u10.dataset.lte, on ? '' : (u10.dataset.min || ''), on ? '' : (u10.dataset.max || ''));
      TC.reopen = null;
      closeAll();
      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) FacetFiltersForm.renderPage(params.toString());
      else window.location.search = params.toString();
      return;
    }

    // Search page: In stock only toggle.
    var avail = t.closest('[data-tc-avail]');
    if (avail) {
      var fa = form();
      if (!fa) return;
      var pa = new URLSearchParams();
      new FormData(fa).forEach(function (v, k) { if (!(v === '' && k.indexOf('filter.v.price') === 0)) pa.append(k, v); });
      var name = avail.dataset.name, value = avail.dataset.value;
      var keep = pa.getAll(name).filter(function (v) { return v !== value; });
      pa.delete(name);
      keep.forEach(function (v) { pa.append(name, v); });
      if (avail.getAttribute('aria-pressed') !== 'true') pa.append(name, value);
      TC.reopen = null;
      closeAll();
      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) FacetFiltersForm.renderPage(pa.toString());
      else window.location.search = pa.toString();
      return;
    }

    var eraChip = t.closest('[data-tc-era-chip]');
    if (eraChip) {
      var values = JSON.parse(eraChip.dataset.values || '[]');
      var name = eraChip.dataset.name;
      var scope = eraChip.getAttribute('data-tc-era-chip') === 'drawer' ? D.el : form();
      if (!scope) return;
      scope.querySelectorAll('input[name="' + CSS.escape(name) + '"]').forEach(function (i) {
        if (values.indexOf(i.value) === -1) return;
        if (i.type === 'checkbox') i.checked = false; else i.remove();
      });
      if (eraChip.getAttribute('data-tc-era-chip') === 'drawer') { syncGroupBoxes(D.el); schedulePreview(null); }
      else { TC.reopen = null; closeAll(); submit(); }
    }
  });
  /* ---------------- Phase 2: card search on Singles pages ----------------
   * The box at the start of the bar (section setting "Show card search")
   * searches without leaving the page. Results come from the search page's
   * section (/search?…&section_id=main-search), kept to this page's scope
   * (Singles, plus the Set on a set page), and replace the products and the
   * bar here — the bar becomes the search page's bar, so every filter still
   * works. The address bar shows this page with ?q=…, so Back/Forward,
   * refresh and sharing all work. Clearing the search (×, the "Search:" chip
   * or Clear all) brings back this page's own products and filters.
   */
  var CS = TC.cardSearch = { on: false, enabled: false, scope: [], seq: 0, cache: {}, full: false, addedStock: false, term: '', gridId: '', gridCols: '', path: '', big: false, browse: '' };
  var AVAIL = 'filter.p.m.custom.filter_online_availability';
  var CS_DROP = ['q', 'type', 'options[prefix]', 'section_id', 'page', 'view'];

  function csBox() { return document.querySelector('[data-tc-card-search]'); }
  function csInput() { var b = csBox(); return b ? b.querySelector('[data-tc-cs-input]') : null; }
  function csIsScope(n, v) { return CS.scope.some(function (s) { return s[0] === n && s[1] === v; }); }
  // The scope's values for one filter (a set page can have several sets).
  function csScopeVals(n) { return CS.scope.filter(function (s) { return s[0] === n; }).map(function (s) { return s[1]; }); }
  function csScopeNames() {
    var names = [];
    CS.scope.forEach(function (s) { if (names.indexOf(s[0]) === -1) names.push(s[0]); });
    return names;
  }
  // True when these values are exactly the scope (nothing narrowed by the shopper).
  function csIsFull(n, vals) {
    var sv = csScopeVals(n);
    if (!sv.length || vals.length !== sv.length) return false;
    return sv.every(function (v) { return vals.indexOf(v) !== -1; });
  }
  // Drops a filter's values when they're just the scope (they aren't the shopper's picks).
  function csStripScope(p) {
    var out = new URLSearchParams();
    var full = {};
    csScopeNames().forEach(function (n) { full[n] = csIsFull(n, p.getAll(n)); });
    p.forEach(function (v, k) { if (!full[k]) out.append(k, v); });
    return out;
  }

  // Big mode (over 5,000 products): any filter pick that isn't the page's own scope.
  function csHasPicks(p) {
    var any = false;
    p.forEach(function (v, k) { if (k.indexOf('filter.') === 0 && v !== '' && !csIsScope(k, v)) any = true; });
    return any;
  }
  // Big mode: with picks, the results come from search with the hidden browse term
  // (data-browse, e.g. Type_Single); without any, from the page itself. Returns true for search.
  function bigNorm(p) {
    var q = (p.get('q') || '').trim();
    if (q && q !== CS.browse) return true;
    if (csHasPicks(p)) { p.set('q', CS.browse); return true; }
    p.delete('q'); p.delete('type'); p.delete('options[prefix]');
    return false;
  }
  function csShownTerm(t) { return t === CS.browse && CS.big ? '' : t; }

  function csFormParams() {
    var f = form();
    var p = new URLSearchParams();
    if (f) new FormData(f).forEach(function (v, k) { if (!(v === '' && k.indexOf('filter.v.price') === 0)) p.append(k, v); });
    return p;
  }

  // Everything the search needs: the term, products only, partial words, the scope.
  function csParams(p) {
    var out = new URLSearchParams();
    var q0 = (p.get('q') || '').trim();
    if (!q0 && CS.big) q0 = CS.browse;
    out.append('q', q0);
    out.append('type', 'product');
    out.append('options[prefix]', 'last');
    p.forEach(function (v, k) {
      if (CS_DROP.indexOf(k) !== -1) return;
      if (v === '' && k.indexOf('filter.v.price') === 0) return;
      out.append(k, v);
    });
    // Scope: a filter the shopper narrowed (e.g. one of this page's sets) stays as picked;
    // otherwise all of the page's values are added.
    csScopeNames().forEach(function (n) {
      if (!out.getAll(n).length) csScopeVals(n).forEach(function (v) { out.append(n, v); });
    });
    if (p.get('page')) out.append('page', p.get('page'));
    return out;
  }
  // What the address bar shows (this page's address + ?q=…&filters).
  function csDisplay(p) {
    var out = new URLSearchParams();
    csStripScope(p).forEach(function (v, k) {
      if (k === 'type' || k === 'options[prefix]' || k === 'section_id' || k === 'view') return;
      if (k === 'q' && CS.big && v === CS.browse) return;
      out.append(k, v);
    });
    return out.toString();
  }
  // Results come from the search.custom-singles template: just the search section, set to
  // "Card search results", so the bar is the Singles bar. If that template isn't
  // installed, Shopify serves the normal search page and the results still work.
  function csUrl(p, section) {
    var q = p.toString();
    return root() + 'search?' + (section ? 'view=custom-singles&' : '') + q;
  }
  function csParse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function csFetch(params) {
    var url = csUrl(params, true);
    if (CS.cache[url]) return Promise.resolve(csParse(CS.cache[url]));
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = csParse(html);
        CS.cache[url] = html;
        return doc;
      });
  }

  function csSync() {
    var input = csInput();
    var x = input && input.closest('[data-tc-card-search]').querySelector('[data-tc-cs-clear]');
    if (x) x.hidden = !(input.value || (CS.on && csShownTerm(CS.term)));
  }

  // Make the search page's grid sit in this page: our box, our grid id and columns.
  function csAdopt(cont, box, term) {
    var side = cont.querySelector('.sidebar-container');
    if (side) side.classList.remove('tc-search');
    var grid = cont.querySelector('#product-grid');
    if (grid) {
      if (CS.gridId) grid.dataset.id = CS.gridId;
      if (CS.gridCols) grid.className = grid.className.replace(/\b(small|medium)-up-\d+\b/g, '').replace(/\s+/g, ' ').trim() + ' ' + CS.gridCols;
    }
    var row = cont.querySelector('.tc-bar__row');
    if (row && box) {
      row.insertBefore(box, row.firstChild);
      box.classList.remove('is-loading');
      var input = box.querySelector('[data-tc-cs-input]');
      if (input && document.activeElement !== input) input.value = csShownTerm(term);
    }
  }

  // The scope (Singles / this set) is always on, so it isn't shown as a choice.
  function csDecorate(scopeEl) {
    if (!CS.on || !scopeEl) return;
    var removed = 0;
    // Chips for the scope are hidden only while the whole scope is on; once the
    // shopper narrows it (one of this page's sets), their pick shows as usual.
    // Whether the shopper narrowed it is read from what was searched (CS.cur), not
    // from the chips: Shopify only lists the values that have results, so a search
    // shows chips for just some of the page's sets.
    var cur = CS.cur || new URLSearchParams();
    var fullNames = csScopeNames().filter(function (n) { return csIsFull(n, cur.getAll(n)); });
    var dropChips = function (sel, attrN, attrV, count) {
      scopeEl.querySelectorAll(sel).forEach(function (c) {
        var n = c.getAttribute(attrN);
        if (fullNames.indexOf(n) !== -1 && csIsScope(n, c.getAttribute(attrV))) { c.remove(); if (count) removed++; }
      });
    };
    dropChips('facet-remove[data-tc-chip-name]', 'data-tc-chip-name', 'data-tc-chip-value', true);
    dropChips('[data-tc-uncheck-name]', 'data-tc-uncheck-name', 'data-tc-uncheck-value', false);
    // The whole scope on = nothing picked: untick those boxes (an unticked list
    // searches all of the page's sets) and drop the count from the filter's label.
    fullNames.forEach(function (n) {
      var touched = [];
      scopeEl.querySelectorAll('input[type="checkbox"][name="' + CSS.escape(n) + '"]').forEach(function (i) {
        if (!csIsScope(n, i.value)) return;
        i.checked = false;
        var box = i.closest('.tc-dd, .tc-sec');
        if (box && touched.indexOf(box) === -1) touched.push(box);
        var opt = i.closest('.tc-opt');
        if (opt) opt.classList.remove('is-on');
      });
      touched.forEach(function (box) {
        if (box.querySelector('input[type="checkbox"][name]:checked')) return;
        var lab = box.querySelector('[data-tc-label]');
        if (lab) lab.textContent = lab.textContent.replace(/\s*\(\d+\)\s*$/, '');
        var val = box.querySelector('.tc-sec__value');
        if (val) val.textContent = '';
        var btn = box.querySelector(':scope > .tc-btn');
        if (btn) btn.classList.remove('is-active');
      });
    });
    if (typeof syncGroupBoxes === 'function') syncGroupBoxes(scopeEl);
    scopeEl.querySelectorAll('.tc-drawer__applied').forEach(function (a) {
      if (!a.querySelector('.tc-chip')) a.style.display = 'none';
    });
    // Set pages: the Set list only offers this page's sets (Shopify lists
    // every set that matches the search, including ones from other pages). If none of
    // them has results, the Set filter is hidden, like any filter with nothing to pick.
    csScopeNames().forEach(function (n) {
      if (!csScopeVals(n).length || !/filter_set_name/.test(n)) return;
      scopeEl.querySelectorAll('.tc-dd[data-key="set"], .tc-sec[data-key="set"]').forEach(function (box) {
        box.querySelectorAll('input[type="checkbox"][name="' + CSS.escape(n) + '"]').forEach(function (i) {
          if (csIsScope(n, i.value) || i.checked) return;
          var opt = i.closest('.tc-opt');
          if (opt) opt.remove();
        });
        var live = Array.prototype.filter.call(box.querySelectorAll('.tc-opt'), function (o) {
          var i = o.querySelector('input');
          if (!i) return false;
          if (i.checked) return true;
          // Shopify keeps the page's own sets in the list even with 0 results, so read the count.
          var c = o.querySelector('.tc-opt__count');
          var n = c ? parseInt(c.textContent, 10) : NaN;
          if (n === 0) { o.classList.add('is-zero'); i.disabled = true; }
          return !i.disabled && !o.classList.contains('is-zero');
        }).length > 0;
        if (!live) { box.hidden = true; box.style.display = 'none'; }
      });
    });
    // A filter fixed to one value (Singles, a one-set page) isn't a choice here.
    csScopeNames().forEach(function (n) {
      if (csScopeVals(n).length !== 1) return;
      var key = /product_type/.test(n) ? 'product_type' : /filter_set_name/.test(n) ? 'set' : '';
      if (!key) return;
      scopeEl.querySelectorAll('.tc-dd[data-key="' + key + '"], .tc-sec[data-key="' + key + '"]').forEach(function (el) {
        el.hidden = true;
        el.style.display = 'none';
      });
    });
    // A price in the scope (Singles Under $10 in big mode) isn't a choice either: no
    // Under $10 toggle and no Price chip while the scope's price is on.
    fullNames.forEach(function (n) {
      if (n.indexOf('filter.v.price') !== 0) return;
      scopeEl.querySelectorAll('[data-tc-under10], [data-tc-u10-check]').forEach(function (el) { el.hidden = true; el.style.display = 'none'; });
      scopeEl.querySelectorAll('[data-tc-price-chip]').forEach(function (c) {
        if (c.closest('.tc-bar')) removed++;
        c.remove();
      });
    });
    var tot = scopeEl.querySelector('.tc-bar [data-tc-total]');
    if (tot && removed) {
      var n = Math.max(0, (parseInt(tot.getAttribute('data-n'), 10) || 0) - removed);
      tot.setAttribute('data-n', n);
      tot.textContent = n > 0 ? ' (' + n + ')' : '';
    }
    // No results: "try removing a filter" only when the shopper has filters on
    // (the page's own scope and In stock only don't count).
    var hint = scopeEl.querySelector('[data-tc-empty-hint]');
    var barForHint = scopeEl.querySelector('.tc-bar');
    if (hint && barForHint) {
      var picked = Array.prototype.some.call(barForHint.querySelectorAll('.tc-chips .tc-chip'), function (c) {
        if (c.hidden || c.closest('[hidden]')) return false;
        var fr = c.closest('facet-remove');
        var n = fr ? (fr.getAttribute('data-tc-chip-name') || '') : '';
        return n.indexOf('online_availability') === -1;
      });
      hint.textContent = picked ? hint.getAttribute('data-filters') : hint.getAttribute('data-plain');
    }
    // "Search: charizard" chip, first in the row of chips.
    var barEl = scopeEl.querySelector('.tc-bar');
    if (barEl && csShownTerm(CS.term) && !barEl.querySelector('[data-tc-clear-search]')) {
      var chips = barEl.querySelector('.tc-chips');
      if (!chips) {
        chips = document.createElement('div');
        chips.className = 'tc-chips';
        chips.innerHTML = '<a href="' + escHtml(CS.path) + '" class="tc-link tc-clear-all">Clear all</a>';
        var row = barEl.querySelector('.tc-bar__row');
        if (row) row.parentNode.insertBefore(chips, row.nextSibling);
      }
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'tc-chip tc-chip--search';
      chip.setAttribute('data-tc-clear-search', '');
      chip.setAttribute('aria-label', 'Clear search: ' + CS.term);
      chip.innerHTML = '<span class="tc-chip__group">Search:</span> \u201C' + escHtml(CS.term) + '\u201D' +
        ' <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      chips.insertBefore(chip, chips.firstChild);
    }
  }

  function csRun(p, opts) {
    opts = opts || {};
    var params = csParams(p);
    var term = params.get('q');
    var seq = ++CS.seq;
    var cont = document.getElementById('ProductGridContainer');
    if (!cont) return;
    if (TC.markPending && !TC.inRefresh) TC.markPending();
    var grid = cont.querySelector('.collection');
    if (grid) grid.classList.add('loading');
    var box = csBox();
    if (box) box.classList.add('is-loading');
    csFetch(params).then(function (doc) {
      if (seq !== CS.seq) return;
      var fresh = doc.getElementById('ProductGridContainer');
      if (!fresh) { window.location.href = csUrl(params, false); return; }
      if (!fresh.querySelector('[data-tc-card-mode]') && window.console) console.warn('[TC card search] Results came without the Singles bar: check that templates/search.custom-singles.json exists and sections/main-search.liquid is the latest copy.');
      var keep = csBox();
      closeAll();
      // A dropdown that was open (an option ticked, or opened while this loaded) opens
      // again on the new bar. A new search from the box clears it first (csSubmit).
      cont.innerHTML = fresh.innerHTML;
      CS.on = true;
      CS.term = term;
      CS.cur = params;
      csAdopt(cont, keep, term);
      csDecorate(cont);
      csSync();
      var disp = csDisplay(params);
      if (typeof FacetFiltersForm !== 'undefined') FacetFiltersForm.searchParamsPrev = disp;
      if (opts.push) history.pushState({ searchParams: disp }, '', CS.path + '?' + disp);
      document.dispatchEvent(new CustomEvent('facets:updated'));
      if (opts.scroll) {
        var top = cont.getBoundingClientRect().top + window.pageYOffset - 100;
        if (window.pageYOffset > top) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }).catch(function () {
      if (seq === CS.seq) window.location.href = csUrl(params, false);
    });
  }

  function csSubmit() {
    var input = csInput();
    if (!input) return;
    TC.reopen = null;
    var term = input.value.trim();
    if (!term) { if (CS.on && csShownTerm(CS.term)) csClear(false); return; }
    var p = csFormParams();
    if (!CS.on) {
      // From this page's own results: keep its filters and drop its sort unless
      // search has it too. (No automatic In stock only here; that's only for the
      // site-wide search page.)
      p.delete('q');
      var sort = p.get('sort_by');
      if (sort !== 'price-ascending' && sort !== 'price-descending') p.delete('sort_by');
      CS.addedStock = false;
    }
    p.set('q', term);
    p.delete('page');
    closeAll();
    TC.reopen = null;
    if (isMobile()) input.blur();
    csRun(p, { push: true });
  }

  // Going back to this page's own results uses the theme's renderPage, which
  // copies the theme's (hidden) active-filters strip before it swaps the grid.
  // The search results don't have that strip, so put an empty one in first;
  // without it the theme stops halfway and the loading spinner never ends.
  function csPrepTheme() {
    var cont = document.getElementById('ProductGridContainer');
    if (cont && !document.querySelector('.active-facets')) {
      var ph = document.createElement('div');
      ph.className = 'active-facets';
      ph.hidden = true;
      cont.appendChild(ph);
    }
  }
  // Safety net: if the page's own results haven't arrived after 10s, load them normally.
  function csWatch(params) {
    clearTimeout(CS.watch);
    var done = function () { clearTimeout(CS.watch); document.removeEventListener('facets:updated', done); };
    document.addEventListener('facets:updated', done);
    CS.watch = setTimeout(function () {
      document.removeEventListener('facets:updated', done);
      window.location.href = CS.path + (params ? '?' + params : '');
    }, 10000);
  }

  function csClear(all) {
    var input = csInput();
    if (input) input.value = '';
    CS.seq++; // drop a search that's still loading
    var p = all ? new URLSearchParams() : csStripScope(csFormParams());
    var out = new URLSearchParams();
    p.forEach(function (v, k) {
      if (CS_DROP.indexOf(k) !== -1 || k === 'sort_by') return;
      if (k === AVAIL && v === 'In Stock' && CS.addedStock) return;
      out.append(k, v);
    });
    // Big mode: filters picked here still need search (the page itself can't filter).
    if (CS.big && csHasPicks(out)) { closeAll(); TC.reopen = null; csRun(out, { push: true }); return; }
    CS.on = false;
    CS.term = '';
    CS.addedStock = false;
    closeAll();
    TC.reopen = null;
    if (CS.renderOrig) { csPrepTheme(); csWatch(out.toString()); CS.renderOrig(out.toString()); }
    else window.location.href = CS.path + (out.toString() ? '?' + out.toString() : '');
  }

  function csInit() {
    var box = csBox();
    if (!box || CS.enabled) return;
    CS.enabled = true;
    try { CS.scope = JSON.parse(box.getAttribute('data-scope') || '[]'); } catch (e) { CS.scope = []; }
    CS.browse = box.getAttribute('data-browse') || '';
    CS.big = !!CS.browse;
    var grid = document.getElementById('product-grid');
    CS.gridId = grid ? grid.dataset.id : '';
    CS.gridCols = grid ? (grid.className.match(/\b(small|medium)-up-\d+\b/g) || []).join(' ') : '';
    CS.path = window.location.pathname;
    // Any filter change with a search term goes to the search instead (filters,
    // sort, chips, Under $10, In stock only, Back/Forward).
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage && !FacetFiltersForm.renderPage.tcWrapped) {
      var orig = FacetFiltersForm.renderPage;
      CS.renderOrig = function () { return orig.apply(FacetFiltersForm, arguments); };
      var wrapped = function (searchParams, event, updateURLHash) {
        var p = new URLSearchParams(searchParams || '');
        if (CS.big) bigNorm(p);
        if ((p.get('q') || '').trim()) return csRun(p, { push: updateURLHash !== false });
        var wasOn = CS.on;
        CS.on = false;
        if (wasOn) { csPrepTheme(); csWatch(p.toString()); }
        var args = Array.prototype.slice.call(arguments);
        args[0] = p.toString();
        return orig.apply(FacetFiltersForm, args);
      };
      wrapped.tcWrapped = true;
      FacetFiltersForm.renderPage = wrapped;
    }
    // Opened with ?q=… (shared link, refresh): run that search.
    var q = new URLSearchParams(window.location.search).get('q');
    if (q && q.trim()) {
      var input = csInput();
      if (input) input.value = csShownTerm(q.trim());
      csRun(new URLSearchParams(window.location.search), { push: false });
    } else if (CS.big && csHasPicks(new URLSearchParams(window.location.search))) {
      // Big mode, opened with ?filter… (refresh, shared link, Back): show those picks.
      csRun(new URLSearchParams(window.location.search), { push: false });
    }
    csSync();
  }
  if (document.readyState === 'complete') csInit();
  else document.addEventListener('DOMContentLoaded', csInit);
  document.addEventListener('facets:updated', csSync);

  // Under $10 on pages with more results than one page shows: the bar can't see every
  // product, so ask Shopify (same filters + "price from $10") whether anything costs $10 or
  // more. If nothing does, the toggle couldn't change the results, so it hides.
  var U10 = { cache: {} };
  function syncUnder10() {
    var wrap = document.querySelector('[data-tc-u10-check]');
    if (!wrap) return;
    var name = wrap.getAttribute('data-name'), value = wrap.getAttribute('data-value');
    if (!name || !value) return;
    var url;
    if (CS.on && CS.cur) {
      var cp = new URLSearchParams(CS.cur.toString());
      cp.delete('page');
      cp.set(name, value);
      url = csUrl(cp, true);
    } else {
      var grid = document.getElementById('product-grid');
      var sid = grid && grid.dataset.id;
      if (!sid) return;
      var p = new URLSearchParams(window.location.search);
      p.delete('page');
      p.set(name, value);
      p.set('section_id', sid);
      url = window.location.pathname + '?' + p.toString();
    }
    var done = function (n) { if (n === 0 && document.body.contains(wrap)) wrap.hidden = true; };
    if (url in U10.cache) { done(U10.cache[url]); return; }
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var c = doc.querySelector('.tc-count');
        var n = c ? parseInt(c.textContent.replace(/[^0-9]/g, ' ').trim().split(' ')[0], 10) : NaN;
        if (isNaN(n)) return;
        U10.cache[url] = n;
        done(n);
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncUnder10);
  else syncUnder10();
  document.addEventListener('facets:updated', function () { setTimeout(syncUnder10, 0); });

  // No results and the drawer would only hold Sort: All Filters has nothing to offer, so it hides.
  // (Filters the shopper picked keep it, so they can change or remove them.)
  function syncAllFilters() {
    var btn = document.querySelector('.tc-btn--all[data-tc-drawer-open]');
    var drawer = document.querySelector('[data-tc-drawer]');
    if (!btn || !drawer) return;
    var empty = !!document.querySelector('.tc-bar__right.is-empty');
    var useful = Array.prototype.some.call(drawer.querySelectorAll('.tc-sec'), function (sec) {
      if (sec.getAttribute('data-key') === 'sort') return false;
      return !sec.hidden && sec.style.display !== 'none' && !sec.closest('[hidden]');
    });
    btn.hidden = empty && !useful;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAllFilters);
  else syncAllFilters();
  document.addEventListener('facets:updated', function () { setTimeout(syncAllFilters, 0); });

  // Search page box (template-header, .tc-sp): × appears once there's text and empties the box.
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('.tc-sp .search-field')) return;
    var x = t.form && t.form.querySelector('[data-tc-sp-clear]');
    if (x) x.hidden = !t.value;
  });
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-tc-sp-clear]');
    if (!x) return;
    e.preventDefault();
    var input = x.form && x.form.querySelector('.search-field');
    if (input) { input.value = ''; input.focus(); }
    x.hidden = true;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-tc-cs-input]')) return;
    e.preventDefault();
    csSubmit();
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-tc-cs-go]')) { e.preventDefault(); csSubmit(); return; }
    if (t.closest('[data-tc-cs-clear]')) {
      e.preventDefault();
      if (CS.on) csClear(false);
      else { var input = csInput(); if (input) { input.value = ''; input.focus(); } csSync(); }
      return;
    }
    if (!CS.on) return;
    if (t.closest('[data-tc-clear-search]')) { e.preventDefault(); csClear(false); return; }
    var all = t.closest('.tc-bar .tc-clear-all');
    if (all && !all.classList.contains('tc-chips-more')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      csClear(true);
      return;
    }
    // Page numbers and "Show out-of-stock products too" stay on this page too.
    var link = t.closest('#ProductGridContainer pagination-theme a, #ProductGridContainer a.tc-show-oos');
    if (link) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var href = link.getAttribute('href');
      if (!href || link.hasAttribute('disabled')) return;
      csRun(new URL(href, window.location.href).searchParams, { push: true, scroll: !!link.closest('pagination-theme') });
    }
  }, true);
})();
